import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { TagsState } from '../../model/map/map';
import { WP_Parent_Tag } from '../../model/tags/tags';
import { ModelsService } from '../../services/ModelsService';
import { AppContext } from '../../state/AppContextProvider';
import { FilterMenuItem } from './FilterMenuItem';

interface FilterMenuProps {
  categories: WP_Parent_Tag[];
  selectParentTag: (number, taxonomy) => void;
  selectedSubTags: TagsState[] | null;
  onResetFilter: () => void;
}

export const FilterMenu: React.FC<FilterMenuProps> = ({
  categories,
  selectParentTag,
  selectedSubTags,
  onResetFilter,
}) => {
  const { state } = useContext(AppContext);
  return (
    <div className="flex flex-col justify-between h-full">
      <div className="relative flex flex-col h-full overflow-hidden">
        <div className="mt-safe-area relative px-8">
          <h2 className="text-xl text-center text-black font-bold mb-8 ">
            <FormattedMessage id="Filter" />
          </h2>
          <button
            className="absolute top-1 right-8 text-primary text-sm"
            onClick={() => {
              onResetFilter();
            }}
          >
            <FormattedMessage id="Reset" />
          </button>
        </div>
        <ul className="h-full overflow-scroll scrollbar-hide px-8 md:thin-scrollbar">
          {categories.map((category, index) => {
            const tagsNames = selectedSubTags?.find(
              (subTag) => subTag.parentTagId === category.id
            );

            category.name = ModelsService.getTranslationFromTerm(
              category,
              state.locale
            );

            return (
              category.count > 0 && (
                <FilterMenuItem
                  id={category.id}
                  title={category.name}
                  color={
                    category.acf.category_place_color
                      ? category.acf.category_place_color
                      : ''
                  }
                  icon={
                    category.acf.category_place_icon?.class
                      ? category.acf.category_place_icon?.class
                      : ''
                  }
                  key={index}
                  tagsNames={tagsNames?.tags}
                  onClick={(e) => {
                    e.preventDefault();
                    selectParentTag(category.id, category.taxonomy);
                  }}
                />
              )
            );
          })}
        </ul>
      </div>
    </div>
  );
};
